"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainBaseUrl = exports.getDomain = exports.domains = void 0;
const theme_1 = require("../utils/theme");
exports.domains = ['caritas', 'bergeinsatz', 'caritascare', 'youngcaritas'];
let _domain;
function getDomain() {
    if (typeof _domain !== 'undefined') {
        return _domain;
    }
    const domain = theme_1.currentTheme;
    if (!isDomain(domain)) {
        throw new Error(`Unknown domain: "${domain}".`);
    }
    _domain = domain;
    return domain;
}
exports.getDomain = getDomain;
function isDomain(domain) {
    return exports.domains.includes(domain);
}
function getDomainBaseUrl() {
    const domain = getDomain();
    switch (domain) {
        case 'caritas':
            return 'https://www.caritas.ch';
        case 'bergeinsatz':
            return 'https://www.bergeinsatz.ch';
        case 'caritascare':
            return 'https://www.caritascare.ch';
        case 'youngcaritas':
            return 'https://www.youngcaritas.ch';
        default:
            throw new UnreachableCaseError(domain);
    }
}
exports.getDomainBaseUrl = getDomainBaseUrl;
class UnreachableCaseError extends Error {
    constructor(val) {
        super(`Unreachable case: ${JSON.stringify(val)}`);
    }
}
